import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { env } from "~/env.mjs";

const defaultBrowserHistory = {
	url: "/",
	location: { pathname: "" },
	listen: () => {
		// no-op
	},
};

let browserHistory = defaultBrowserHistory;
if (typeof window !== "undefined") {
	browserHistory = { ...browserHistory, ...window.history };
	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
	browserHistory.location.pathname =
		// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
		(browserHistory as unknown as History)?.state?.url;
}

export const AIReactPlugin = new ReactPlugin();
export const insights = new ApplicationInsights({
	config: {
		connectionString: env.NEXT_PUBLIC_INSIGHTS_CONNECTION_STRING,
		maxBatchInterval: 15_000,
		maxBatchSizeInBytes: 10_000,
		accountId: "webapp",
		extensions: [AIReactPlugin],
		extensionConfig: {
			[AIReactPlugin.identifier]: { history: browserHistory },
		},
	},
});

insights.loadAppInsights();
